import { useState } from 'react';
import { WindowSize } from './useWindowSize.typed';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

// Taken from: https://usehooks.com/useWindowSize
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
  });
  // Since this returns window size, we need it to happen before the first DOM paint.
  // Otherwise, we'll be at risk for flicker.
  useIsomorphicLayoutEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};

export { useWindowSize };
